module.exports = __webpack_public_path__ + "img/i-role-min4.0da30dce.png";